import { insertCommasIntoNumber } from '@trukt/portal-utils/insertCommasIntoNumber';
import { Typography } from '../../Typography';
import { ArrowLeft, ArrowRight } from '../../icons';
import { Button } from '../../buttons/Button';

import { useStyles } from './PageNumbers.styles';
import { PageNumber } from './PageNumber/PageNumber';

import { PaginationProps } from '../Pagination.types';
import { RenderWhen } from '../../RenderWhen';

export type PageNumbersProps = Pick<
  PaginationProps,
  | 'currentPage'
  | 'onPageSelect'
  | 'totalPages'
  | 'totalRecords'
  | 'isInfinite'
  | 'isNextPageAvailable'
>;

export const PageNumbers = ({
  currentPage = 1,
  totalPages = 1,
  onPageSelect = () => {},
  isInfinite = false,
  isNextPageAvailable = true,
}: PageNumbersProps) => {
  const styles = useStyles();
  return (
    <div css={styles.container}>
      <Button
        css={styles.button}
        color="secondary"
        aria-label="Previous page"
        size="sm"
        onClick={() => onPageSelect(currentPage - 1 > 0 ? currentPage - 1 : totalPages)}
      >
        <ArrowLeft
          role="img"
          aria-label="Paginate left"
          size="1.2rem"
          className="cursor-pointer stroke-primary-400"
        >
          <title>Paginate left</title>
        </ArrowLeft>
      </Button>
      <Typography>Page </Typography>
      <PageNumber
        page={currentPage}
        isInfinite={isInfinite}
        isNextPageAvailable={isNextPageAvailable}
        totalPages={totalPages}
        onPageSelect={onPageSelect}
        isActive
      />
      <Typography className={isInfinite ? 'w-5' : 'w-14'}>
        <RenderWhen condition={!isInfinite}>of {insertCommasIntoNumber(totalPages)}</RenderWhen>
      </Typography>
      <Button
        css={styles.button}
        color="secondary"
        aria-label="Next page"
        disabled={isInfinite ? !isNextPageAvailable : undefined}
        size="sm"
        onClick={() => {
          const condition = isInfinite ? isNextPageAvailable : currentPage + 1 <= totalPages;
          onPageSelect(condition ? currentPage + 1 : 1);
        }}
      >
        <ArrowRight
          role="img"
          aria-label="Paginate right"
          size="1.2rem"
          className="stroke-primary-400"
        >
          <title>Paginate right</title>
        </ArrowRight>
      </Button>
    </div>
  );
};
